import { childForms as affiliationForms } from './affiliation-routes';
import { childForms as authChildForms } from './auth-routes';
import { childForms as citizenChildForms } from './citizen-routes';
import { childForms as cleanForms } from './clean-routes';
import { childForms as creditChildForms } from './credits-routes';
import { childForms as dashboardChildForms } from './dashboard-routes';
import { childForms as homeChildForms } from './home-routes';
import { childForms as notificationsChildForms } from './notifications-routes';
import { childForms as productsChildForms } from './products-routes';
import { childForms as publicChildForms } from './public-routes';

export const formRoutes = {
  affiliation: { path: 'affiliation', childForms: affiliationForms, layout: 'main' },
  auth: { path: 'auth', childForms: authChildForms, layout: 'auth' },
  citizen: { path: 'citizen', childForms: citizenChildForms, layout: 'main' },
  cleanForms: { path: 'clean', childForms: cleanForms, layout: 'auth' },
  credits: { path: 'credits', childForms: creditChildForms, layout: 'main' },
  dashboard: { path: 'dashboard', childForms: dashboardChildForms, layout: 'main' },
  home: { path: 'home', childForms: homeChildForms, layout: 'main' },
  notifications: { path: 'notifications', childForms: notificationsChildForms, layout: 'main' },
  products: { path: 'products', childForms: productsChildForms, layout: 'main' },
  public: { path: 'public', childForms: publicChildForms, layout: 'auth' },
};

export const standardRoutes = {
  EMPTY: '',
  ANY: '**',
  DEFAULT: 'citizenHomeRedirect',
  HOME: 'citizenHomeRedirect',
  LOGIN: 'citizenHomeRedirect',
  NOTFOUND: 'notfound',
  OPENIDLOGIN: 'openidlogin',
  REGISTER: 'registerUser',
  SESSIONBASED_HOME: 'mainDashboard',
  // SESSIONLESS_HOME: 'citizenHomeRedirect',
  SESSIONLESS_HOME: 'citizenPublicHome',
  UNAUTHORIZED: 'unauthorized',
};
